import { useState, useEffect } from "react";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import Chat from "../../compoenents/Chat";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheck/page";
import { AppValues, API, ApiUrl } from "../../Values";
export default function CustomerAdressSaved(order) {
  const [Data, SetData] = useState([]);
  //---------CHECK LOGIN------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }
  //--------------------------------------------
  //--------------------------------------------
  const params = useParams();
  const style = {
    fontSize: "14px",
    color: "#666",
    fontWeight: "bold",
  };

  useEffect(() => {
    GetData();
  }, []);
  async function GetData() {
    try {
      const post = {
        Name: Username,
        ID: UserID,
        Action: "GETAdresses",
      };
      const respons = await fetch(API.CustomerAccount, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await respons.json();
      SetData(data.data);
    } catch (error) {
      return error;
    }
  }
  //=============================
  async function delete_(x) {
    try {
      const post = {
        Name: Username,
        ID: UserID,
        Action: "DeleteAdress",
        Address: x,
      };
      console.log(post)
      const respons = await fetch(API.CustomerAccount, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await respons.json();
      GetData();
    } catch (error) {
      return error;
    }
  }

  return (
    <>
      <div
        dir="rtl"
        className="row mt-0 pt-2 text-center0 m-auto "
        style={{ maxWidth: "500px" }}
      >
        <div className="col-1 py-1 bg-info0 ">
          <Link to="../Customer/Account">
            <i className="fa-solid fa-chevron-right  text-dark0 mt-2 fs-4"></i>
          </Link>
        </div>
        <div className="col-8 py-1 text-center bg-info0 text-white0">
          <h4>{"  العناوين المحفوظة "}</h4>
        </div>
        <div className="col-3 py-1 text-center">
          <Link to="../Customer/AdressAdd">
            <button className="btn btn-green text-white fw-bolder p-0 px-1">
              {/* <i className="fa-solid fa-square-plus text-green ps-1">  </i> */}
              <i className="fa-solid fa-plus ps-1 fw-bold">  </i>
              اضافة
            </button>
          </Link>

        </div>
        {/* <hr /> */}
        {/* <div className="col-12 pt-1 px-1 text-center mb-2">
          <Link to="../Customer/AdressAdd">
            <label
              dir="ltr"
              className="fs-4 fw-bold btn-green p-1 w-100 shadow"
            >
              اضافة عنوان <i className="fa-solid fa-plus"></i>
            </label>
          </Link>
        </div> */}
        <div className="col-master col-card-alert col-12 p-0 mb-4 pt-1">
          {Data.length > 0 ?
            Data.map((x, index) => {
              return (
                <div key={index} className="row bg-white m-2 shadow" style={{ minHeight: "80px" }}>

                  <div className="col-11 pt-1">
                    <h6 className="text-dark0 p-0 m-0 mt-2">
                      {x.Address}
                    </h6>
                    {x.Title != "" && <><small className="text-syan">{x.Title}</small><br /></>}
                    <i className="text-green fa-solid fa-camera"></i>
                  </div>
                  <div className="col-1">
                    <i className="text-danger fa-regular fa-trash-can mt-4" onClick={() => delete_(x.Address)}></i>
                  </div>
                </div>
              );
            }) : <h4 className="text-orange text-center text-danger mt-4 ">لا توجد عناوين محفوظة

            </h4>}
        </div>
      </div>
    </>
  );
}
